<template>
  <div>
    <div class="c-page-banner c-page-banner--no-size" :class="position ? 'c-page-banner--' + position : ''" v-if="images.length > 1">
      <div class="c-gallery">
        <div ref="gallery">
          <div class="c-page-banner__image" v-for="image in images" :key="image.id">
            <img :src="image.url" alt="">
            <div class="c-page-banner__credit u-st2" v-if="image.credit">&copy; {{ image.credit }}</div>
          </div>
        </div>
        <button class="c-gallery__btn c-gallery__btn--prev" @click="prevImage">
          <img src="@/assets/caret-left-blue.svg" height="32" alt="Left caret">
        </button>
        <button class="c-gallery__btn c-gallery__btn--next" @click="nextImage">
          <img src="@/assets/caret-right-blue.svg" height="32" alt="Right caret">
        </button>
      </div>
      <div class="c-page-banner__content o-box-off">
          <h1 class="c-page-banner__heading" v-if="heading">{{ heading }}</h1>
          <p class="c-page-banner__subheading u-h5" v-if="subheading">{{ subheading }}</p>
          <router-link class="c-btn c-btn--secondary" :to="{ name: 'about' }" v-if="readMore">Read more</router-link>
          <a class="c-read-more c-read-more--reversed" href="#" v-if="scrollToContent" v-scroll-to="'#scroll-content'">
            <img class="c-read-more__img" src="@/assets/arrow-down-blue.svg" width="32" alt="Down arrow"> Read more
          </a>
        </div>
    </div>
    <div class="c-page-banner c-page-banner--no-size" :class="position ? 'c-page-banner--' + position : ''" v-else>
      <div class="c-page-banner__image">
        <img :src="images[0].url" alt="">
        <div class="c-page-banner__credit u-st2 u-mt+ u-mt0@tablet" v-if="images[0].credit">&copy; {{ images[0].credit }}</div>
      </div>
      <div class="c-page-banner__content o-box-off">
        <h1 class="c-page-banner__heading" v-if="heading">{{ heading }}</h1>
        <p class="c-page-banner__subheading u-h5" v-if="subheading">{{ subheading }}</p>
        <router-link class="c-btn c-btn--secondary" :to="{ name: 'about' }" v-if="readMore">Read more</router-link>
        <a class="c-read-more c-read-more--reversed" href="#" v-if="scrollToContent" v-scroll-to="'#scroll-content'">
          <img class="c-read-more__img" src="@/assets/arrow-down-blue.svg" width="32" alt="Down arrow"> Read more
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Siema from 'siema'

export default {
  name: 'Hero',
  props: {
    heading: {
      type: String,
      required: true
    },
    subheading: {
      type: String
    },
    position: {
      type: String
    },
    images: {
      type: Array,
      required: true
    },
    readMore: {
      type: Boolean,
      default: false
    },
    scrollToContent: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.initGallery()
  },
  methods: {
    initGallery () {
      let selector = this.$refs.gallery
      this.mySiema = new Siema({
        selector: selector,
        loop: true,
        draggable: false,
        duration: 800
      })
    },
    prevImage () {
      this.mySiema.prev()
    },
    nextImage () {
      this.mySiema.next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Hero.vue